module.exports = __webpack_public_path__ + "img/ic_grade_VVIP.feda770.png";